import { axiosInstance } from "./apiConfig"

export const apiGetPromotions = async (storeId, date, time, covers, language = 'en') => {
    const response = await axiosInstance.get(`/thirdparty/resdiary/store/${storeId}/promotion?date=${date}&time=${time}&covers=${covers}&language=${language}`);
    return response.data;
}


// WEBPACK FOOTER //
// ./src/api/getPromotions.js